import { useNavigate } from "react-router-dom";
import { Background } from "../../common/components";
import {
  Header,
  HeaderTextWrapper,
  HeaderAnimationText,
  HeaderText,
} from "./DetailPageLayout.styles";
import { ArrowBackIcon } from "./DetailPageLayout.styles";
import { useEffect, useState } from "react";

const DetailPageLayout = ({ children, headerText, onClickGoBack }) => {
  const navigate = useNavigate();
  const [isShowTextLoop, setIsShowTextLoop] = useState(false);

  // decimal의 charCodeAt 0~127라면 1 byte, 아니라면 2byte 반환
  function getByteLength(decimal) {
    return decimal >> 7 ? 2 : 1;
  }

  // maxByte 이상이라면 true
  function IsOverLimitedTextByte(inputText, maxByte) {
    const characters = inputText.split("");
    let totalByte = 0;

    for (let i = 0; i < characters.length; i += 1) {
      const decimal = characters[i].charCodeAt(0);
      const byte = getByteLength(decimal);

      if (totalByte + byte <= maxByte) {
        totalByte += byte;
      } else {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    if (headerText) {
      setIsShowTextLoop(IsOverLimitedTextByte(headerText, 40));
    }
  }, []);

  const goBack = () => navigate(-1);

  return (
    <Background>
      <Header>
        {isShowTextLoop ? (
          <HeaderTextWrapper>
            <HeaderAnimationText>{headerText}</HeaderAnimationText>
          </HeaderTextWrapper>
        ) : (
          <HeaderText>{headerText}</HeaderText>
        )}
        <ArrowBackIcon onClick={onClickGoBack ? onClickGoBack : goBack} />
      </Header>
      {children}
    </Background>
  );
};

export default DetailPageLayout;
